export default __webpack_public_path__ + "static/media/151-ventilation.4a92b905.png";